import { configureStore } from "@reduxjs/toolkit";
import fileSlice from "./file-attachement-slice";
import formSlice from "./form-slice";
import submitSlice from "./submit-form-slice";
import loadFormSlice from "./load-form-slice";
import fipsCodesSlice from "./fips-code-slice";

const store = configureStore({
  reducer: {
    form: formSlice.reducer,
    loadForm: loadFormSlice.reducer,
    submit: submitSlice.reducer,
    files: fileSlice.reducer,
    fipsCodes: fipsCodesSlice.reducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
